import React from "react";
import DataPHead from "../../component/DataPHead/DataPHead";
import { Link } from "react-router-dom";

const DataP = () => {
  return (
    <>
      <DataPHead />
      <section id="service-details" className="service-details">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-4 mobcol">
            <div className="col-lg-12">
              <h3>Data Protection</h3>

              <ul>
                <p>
                  Data protection plays a crucial role in achieving sustainable
                  development goals by ensuring the responsible and ethical use
                  of data. Data Protection Regulation is a big business and this
                  innovation will provide a platform where this regulation can
                  be used to create jobs, ensure quality education, reduce
                  inequalities and foster partnership arrangement among other
                  goals of the United Nations.
                  <br />
                  <br /> This work will address data protection from two
                  different perspectives:
                </p>
                <p style={{ paddingLeft: "19px" }}>
                  <span className="bolder">1.</span> Data Protection concept
                  from inception of this platform and continuous improvement
                  throughout the life span of the project. Protecting
                  individuals' privacy is a fundamental aspect of data
                  protection. By safeguarding personal information, data
                  protection measures contribute to building trust between
                  individuals, organizations, and governments. This website will
                  ensure that all the principles of Data Protection Regulations
                  as in General Data Protection Regulation (GDPR) and Nigeria
                  Data Protection Act (NDPA) are duly observed. This will help
                  build trust among the participating members of the platfrom.
                </p>
                <p style={{ paddingLeft: "19px" }}>
                  <span className="bolder">2.</span> Data Protection concept as
                  a potent instrument that can be used to create jobs, provide
                  quality education, and foster strong partnership relationship
                  among the participating members of this innovation.
                  Alternatively, the website will encourage members to carry
                  campaign work of data protection regulation to their locality
                  and become agents of change that will foster quality education
                  on the subject and turn the tide to favor as many young people
                  that will embrace the race for job opportunity. The concept of
                  responsible data governance and ethical principle of data
                  collection will be adhered to. It will be an educative aspect
                  that will establish clear guidelines for data collection,
                  processing and sharing in ethical and transparent manner. All
                  opportunities that are available for members to tap into for
                  job creation and awareness activities will be looked upon.
                </p>
              </ul>
              {/* <p>
                You can{" "}
                <Link to={`${process.env.PUBLIC_URL}/contact`}>contact</Link> us
                for a demonstration of this software.
              </p> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DataP;
